import React, {useCallback, useState, useEffect} from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
import * as serviceWorkerRegistration from "../../serviceWorkerRegistration";

export default function Header({ menuToggleEnabled, title, toggleMenu }) {
  const Refreshdata = useCallback(() => {
    window.location.reload(true);
  }, []);

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [isAppInstalled, setIsAppInstalled] = useState(false);

  useEffect(() => {
    // Проверка поддержки PWA и статуса установки
    const checkPWA = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      setIsAppInstalled(isStandalone || (isIOS && navigator.standalone));
      
      const isSupported = window.hasOwnProperty('BeforeInstallPromptEvent') || 
        isStandalone ||
        (navigator.standalone) ||
        document.referrer.includes('android-app://');
      
      setSupportsPWA(isSupported);
    };

    checkPWA();

    const beforeInstallHandler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setSupportsPWA(true);
    };

    window.addEventListener('beforeinstallprompt', beforeInstallHandler);
    window.addEventListener('appinstalled', () => setIsAppInstalled(true));

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
      window.removeEventListener('appinstalled', () => setIsAppInstalled(false));
    };
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
          setIsAppInstalled(true);
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
      });
    } else {
      // Альтернативное поведение для неподдерживаемых браузеров
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        alert('Для установки приложения:\n1. Откройте меню браузера\n2. Выберите "Добавить на главный экран"');
      } else {
        alert('В вашем браузере нажмите кнопку "Установить" в адресной строке или меню браузера');
      }
    }
  };

  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title'}
          text={title}
          visible={!!title}
        />

        {supportsPWA && !isAppInstalled && (
          <Item location={'after'} locateInMenu={'auto'}>
            <Button 
              onClick={handleInstall}
              className="install-button"
              stylingMode="contained"
              text="Установить"
              icon="download"
            />
          </Item>
        )}
        
        <Item location={'after'} locateInMenu={'auto'}>
          <Button 
            className="refresh-button"
            stylingMode="contained" 
            icon="refresh" 
            onClick={Refreshdata}
            hint="Обновить данные"
          />
        </Item>

       
      </Toolbar>
    </header>
  );
}